import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import styled from 'styled-components';
import { noop } from 'lodash';
import { Checkbox as UnstyledCheckbox } from '@zocdoc/components/src/Checkbox';
import CollapsibleSection from '@zocdoc/components/src/CollapsibleSection';
import { FontFamily } from '@zocdoc/components/src/typography';

export const LOCALIZED_STRINGS = defineMessages({
    Title: {
        id: 'Components.RefineSearch.TimeOfDay.Title',
        defaultMessage: `{count, plural,
            =0 {special hours}
            other {special hours (#)}
        }`,
    },
    Before10AM: {
        id: 'Components.RefineSearch.TimeOfDay.Before10AM',
        defaultMessage: 'before 10:00 am',
    },
    After5PM: {
        id: 'Components.RefineSearch.TimeOfDay.After5PM',
        defaultMessage: 'after 5:00 pm',
    },
});

export const Checkbox = styled(UnstyledCheckbox)`
    font-family: ${FontFamily.SharpSansSemibold};
`;

const TimeOfDayFilter = ({
    defaultOpen,
    intl,
    numApplied,
    onChangeCallback,
    showTimesAfter5,
    showTimesBefore10,
    trackFilterClickSpecialHours = noop,
}) => {
    const title = intl.formatMessage(LOCALIZED_STRINGS.Title, {
        count: numApplied,
    });

    const before10am = intl.formatMessage(LOCALIZED_STRINGS.Before10AM);
    const after5pm = intl.formatMessage(LOCALIZED_STRINGS.After5PM);

    const handleCheckBefore10 = update => {
        if (update !== showTimesBefore10) {
            const newState = { showTimesBefore10: update };
            const trackingLabel = update ? 'Checked Before 10' : 'Unchecked Before 10';

            trackFilterClickSpecialHours(trackingLabel);
            onChangeCallback(newState);
        }
    };

    const handleCheckAfter5 = update => {
        if (update !== showTimesAfter5) {
            const newState = { showTimesAfter5: update };
            const trackingLabel = update ? 'Checked After 5' : 'Unchecked After 5';

            trackFilterClickSpecialHours(trackingLabel);
            onChangeCallback(newState);
        }
    };

    return (
        <CollapsibleSection
            data-test="search-refine-timeofday-filter"
            defaultOpen={defaultOpen}
            headerText={title}
        >
            <Checkbox
                checked={showTimesBefore10}
                data-test="search-refine-timeofday-filter-before10am"
                onChecked={handleCheckBefore10}
            >
                {before10am}
            </Checkbox>
            <Checkbox
                checked={showTimesAfter5}
                data-test="search-refine-timeofday-filter-after5pm"
                onChecked={handleCheckAfter5}
            >
                {after5pm}
            </Checkbox>
        </CollapsibleSection>
    );
};

TimeOfDayFilter.propTypes = {
    defaultOpen: PropTypes.bool,
    numApplied: PropTypes.number,
    onChangeCallback: PropTypes.func.isRequired,
    showTimesAfter5: PropTypes.bool.isRequired,
    showTimesBefore10: PropTypes.bool.isRequired,
    trackFilterClickSpecialHours: PropTypes.func,
};

export default injectIntl(TimeOfDayFilter);
